import store from '../store';

const TopMessageHandler = new class
{
    show(message: string, cssClassName: string, callback: VoidFunction|null = null, seconds: number = 5)
    {
        if (seconds < 1)
        {
            throw new Error('invalid seconds parameter');
        }

        store.commit('topMessageAdd', {
            message,
            cssClassName,
            callback,
            seconds,
        });
    }

    success(message: string, callback?: VoidFunction|null, seconds = 5)
    {
        this.show(message, 'success', callback, seconds);
    }

    error(message: string, callback?: VoidFunction|null, seconds = 5)
    {
        this.show(message, 'error', callback, seconds);
    }

    info(message: string, callback?: VoidFunction|null, seconds = 5)
    {
        this.show(message, 'info', callback, seconds);
    }
};

export default TopMessageHandler;
